import request from '@/util/request';
import qs from 'qs';

//指令号
export const getOrderNumber = (params, options) =>
  request.get('/api/common/getOrderNumber', Object.assign({}, options, { params }));
//获取项目字典
export const getBisDictData = (params, options) =>
    request.get('/api/v4ward/projectDict/dictionary', Object.assign({}, options, { params }));
export const getDictionary = (code, options) =>
  request.get('/api/blade-system/dict/dictionary?code=' + code, Object.assign({}, options, {}));

export const getDictionaryWithIntKey = (code, options) =>
  request.get(
    '/api/blade-system/dict/dictionaryWithIntKey?code=' + code,
    Object.assign({}, options, {})
  );

export const getProperty = (objectTypeKey, options) =>
  request.get(
    '/api/base/property/tree1?objectTypeKey=' + objectTypeKey,
    Object.assign({}, options, {})
  );
/**
 * 获取当前登陆人下的部门和子部门
 * @param code
 * @param options
 * @returns {AxiosPromise<any>}
 */
export const selectDept = (code, options) =>
  request.get('/api/repair/selectDept', Object.assign({}, options, {}));

/**
 * 根据部门id获取部门人员
 * @param code
 * @param options
 * @returns {AxiosPromise<any>}
 */
export const selectUser = (code, options) =>
  request.get('/api/repair/selectUser?deptId=' + code, Object.assign({}, options, {}));

//获取欠费信息
export const getCommunityGroupList = (params, options) =>
  request.get('/api/base/property/common/communityGroup', Object.assign({}, options, { params }));
